import { type MetaFunction } from '@remix-run/node'
import productRenters from './product-renters.png'

export const meta: MetaFunction = () => [
	{ title: 'Renters Insurance' },
	{
		name: 'description',
		content: 'We offer renters insurance.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">Renters Insurance</h1>
			<img
				src={productRenters}
				alt="A hand holding a key"
				className="rounded-lg object-cover object-center"
			/>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				Even if you don't own the home you live in, it is still very important
				to make sure to cover the personal property contents. Your landlord will
				be responsible for covering the building, but as the tenant, your job is
				to secure a policy that provides coverage for your personal belongings.
				The type of policy that is appropriate in this situation is called
				Renters insurance, tenant insurance, or form HO4.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				A renters policy has a few components:
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				1. Personal Property coverage
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				You will select a limit of coverage that represents the value your
				personal belongings. There may be sub-limits on certain types of
				property such as jewelry, guns, and money. There will be a deductible
				applied to any claim payments made for personal property coverage. Most
				insurers require that you select a coverage limit of at least $25,000,
				although you should exercise caution and complete a home inventory
				before selecting a limit. It's important to make sure that you have
				sufficient coverage for everything. Where possible, you should attempt
				to get Replacement Cost Coverage for your personal property. This means
				that you will be able to replace items with brand new items. Without
				replacement cost coverage, you probably will not receive enough money in
				the settlement of the claim to buy substitute items.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				2. Loss of Use
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				If your home is damaged and unusable as a result of a covered claim,
				your renters policy may include a coverage that will temporarily help
				you cope with the increased financial burden of staying a hotel or
				finding alternate living space while the damage to your home is being
				repaired.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				3. Personal liability
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				This coverage provides defense and pays your legal obligation as a
				result of a lawsuit following an injury at your home or caused by a
				covered member of your household.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				4. Medical payments.
			</p>
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				If a guest is hurt at your home, you might be glad that you have medical
				payments coverage on your renters policy. The limit of coverage is
				typically between $1,000 and $5,000. It is designed as a goodwill step
				in helping a guest recover from the financial impact of an accident.
				Scenario: Shirley invites her best friend Helen over for Sunday dinner.
				Helen offers to take the red raspberry pie out of the oven and sustains
				a burn when the tasty filling spills over the side of the pie plate.
				Recognizing the gravity of the situation, Shirley and Helen visit an
				urgent care facility so that treatment can be administered. Shirley's
				medical payments coverage pays for the visit to urgent care to treat the
				severe burns. Helen suggests that next time they get together, ice cream
				sundaes will be a better choice, and doesn't sue Shirley.
			</p>
		</main>
	)
}
